import { Box } from '@mui/material';

const GradientBackground = () => {
  return (
    <Box
      sx={{
        background:
          'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)',
        height: '28%',
        width: '100%',
        position: 'absolute',
        bottom: 0,
        left: 0,
        zIndex: 9,
        borderRadius: 'inherit',
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
      }}
    />
  );
};

export default GradientBackground;
